<template>
  <div class="row">
    <div class="col col-md-12">
      <div
        v-if="mensagem !== '' && view !== 'modal'"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        :id="'dialogDiretorioListFiltro'"
        ref="dialogDiretorioListFiltro"
        :hide-header="true"
        :modal="view == 'modal'"
        tamanho="xl"
      >
        <div>
          <div class="d-flex justify-content-end">
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1" @click="$emit('dialog-off')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.5"
                    x="6"
                    y="17.3137"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(-45 6 17.3137)"
                    fill="currentColor"
                  ></rect>
                  <rect
                    x="7.41422"
                    y="6"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(45 7.41422 6)"
                    fill="currentColor"
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div class="fv-row mb-7 text-center">
            <h2 class="fw-bolder">Filtrar</h2>
          </div>
        </div>

        <div>
          <div class="m-3" v-if="storeArvore?.instancias[instancia] && false">
            <h1 class="d-flex justify-content-center fs-2 mt-2">
              <span
                class="fs-7 mt-2 cursor-pointer"
                :class="{
                  'fw-bolder':
                    storeArvore.instancias[instancia].filtroTipoObjeto ==
                    'arquivos',
                  'text-success':
                    storeArvore.instancias[instancia].filtroTipoObjeto ==
                    'arquivos',
                  'fw-normal':
                    storeArvore.instancias[instancia].filtroTipoObjeto !==
                    'arquivos',
                  'text-dark':
                    storeArvore.instancias[instancia].filtroTipoObjeto !==
                    'arquivos'
                }"
                @click="
                  storeArvore.instancias[instancia].filtroTipoObjeto =
                    'arquivos'
                "
                >Arquivos</span
              >
              <span
                class="h-22px border-1 border-gray-200 border-start ms-3 mx-2 me-1"
              ></span>
              <span
                class="fs-7 ms-2 mt-2 cursor-pointer"
                :class="{
                  'fw-bolder':
                    storeArvore.instancias[instancia].filtroTipoObjeto ==
                    'diretorios',
                  'text-success':
                    storeArvore.instancias[instancia].filtroTipoObjeto ==
                    'diretorios',
                  'fw-normal':
                    storeArvore.instancias[instancia].filtroTipoObjeto !==
                    'diretorios',
                  'text-dark':
                    storeArvore.instancias[instancia].filtroTipoObjeto !==
                    'diretorios'
                }"
                @click="
                  storeArvore.instancias[instancia].filtroTipoObjeto =
                    'diretorios'
                "
                >Pastas</span
              >
            </h1>
          </div>

          <div
            class="row mb-5"
            :class="{
              'd-none': authStore?.sessao.usuario.tipoUsuario == 'adminNuvem'
            }"
          >
            <div class="col-6">
              <label class="fs-6 fw-bold mb-2">Compartilhamento</label>
              <Combo
                v-model="
                  storeArvore.instancias[instancia].filtroCompartilhamento
                "
                :itens="compartilhamentos"
                autofocus="true"
                :classSelect2="false"
                v-if="storeArvore?.instancias[instancia]"
              />
            </div>
          </div>

          <div class="fv-row mb-3">
            <label class="fs-6 fw-bold mb-2">Nome do arquivo</label>

            <input
              v-model="storeArvore.instancias[instancia].filtroNome"
              class="form-control form-control-solid"
              type="text"
              autofocus="true"
              autocomplete="off"
              placeholder="exemplo.pdf, *.pdf"
              v-if="storeArvore?.instancias[instancia]"
            />
          </div>

          <div class="fv-row mb-3">
            <label class="fs-6 fw-bold mb-2">Caminho completo</label>

            <input
              v-model="storeArvore.instancias[instancia].filtroDiretorio"
              class="form-control form-control-solid"
              type="text"
              autofocus="true"
              autocomplete="off"
              placeholder="/pasta/subpasta/exemplo.pdf, /pasta/*"
              v-if="storeArvore?.instancias[instancia]"
            />
          </div>

          <div class="row mb-5">
            <label class="fs-6 fw-bold mb-2">Data</label>
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">De</label>
              <div class="d-flex">
                <input
                  v-model="storeArvore.instancias[instancia].filtroDataInicio"
                  class="form-control form-control-solid me-2"
                  type="date"
                  autofocus="true"
                  autocomplete="off"
                  v-if="storeArvore?.instancias[instancia]"
                />
                <input
                  v-model="storeArvore.instancias[instancia].filtroHoraInicio"
                  class="form-control form-control-solid"
                  type="time"
                  autofocus="true"
                  autocomplete="off"
                  v-if="storeArvore?.instancias[instancia]"
                />
              </div>
            </div>
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">Até</label>
              <div class="d-flex">
                <input
                  v-model="storeArvore.instancias[instancia].filtroDataFim"
                  class="form-control form-control-solid me-2"
                  type="date"
                  autofocus="true"
                  autocomplete="off"
                  v-if="storeArvore?.instancias[instancia]"
                />
                <input
                  v-model="storeArvore.instancias[instancia].filtroHoraFim"
                  class="form-control form-control-solid"
                  type="time"
                  autofocus="true"
                  autocomplete="off"
                  v-if="storeArvore?.instancias[instancia]"
                />
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <label class="fs-6 fw-bold mb-2"
              >Tamanho <span class="text-muted">(mb)</span></label
            >
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">De</label>
              <input
                v-model="storeArvore.instancias[instancia].filtroTamanhoInicio"
                class="form-control form-control-solid me-2"
                type="text"
                autofocus="true"
                autocomplete="off"
                v-if="storeArvore?.instancias[instancia]"
              />
            </div>
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">Até</label>
              <input
                v-model="storeArvore.instancias[instancia].filtroTamanhoFim"
                class="form-control form-control-solid"
                type="text"
                autofocus="true"
                autocomplete="off"
                v-if="storeArvore?.instancias[instancia]"
              />
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-6">
              <label class="fs-6 fw-bold mb-2">Usuário</label>
              <Combo
                v-model="storeArvore.instancias[instancia].filtroUsuario"
                :itens="usuarios"
                autofocus="true"
                :classSelect2="false"
                v-if="storeArvore?.instancias[instancia]"
              />
            </div>
            <div class="col-6">
              <label class="fs-6 fw-bold mb-2">Excluídos</label>
              <Combo
                v-model="storeArvore.instancias[instancia].filtroExcluidos"
                :itens="[
                  { id: true, nome: 'Sim' },
                  { id: false, nome: 'Não' }
                ]"
                autofocus="true"
                :classSelect2="false"
                v-if="storeArvore?.instancias[instancia]"
              />
            </div>
          </div>
        </div>

        <template #rodape>
          <div class="row">
            <div
              class="col-md-12 col-sm-12 d-flex justify-content-center"
              style="align-items: center; padding: 0.75rem"
            >
              <button
                type="button"
                class="btn btn-secondary me-1"
                @click="limpar()"
              >
                Limpar
              </button>
              <button type="button" class="btn btn-warning" @click="fechar()">
                Aplicar
              </button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";
import { useAuthStore } from "@/stores/auth.js";
import { useStoreArvore } from "../stores/storeArvore.js";

import Dialog from "../components/ComponentDialog.vue";
import Combo from "../components/ComponentCombo.vue";

export default {
  components: { Combo, Dialog },
  props: {
    view: { type: String, default: "modal" },
    instancia: { type: String, default: "" },
    item: {
      type: String,
      default: () => {
        return { usuario: "" };
      }
    }
  },

  computed: {},

  data() {
    return {
      usuarios: [],
      compartilhamentos: [],
      authStore: null,
      storeArvore: null
    };
  },

  mounted() {
    this.authStore = useAuthStore();
    this.storeArvore = useStoreArvore();

    if (this.authStore?.sessao.usuario.tipoUsuario == "usuarioNuvem") {
      //* Carrega os compartilhamentos
      this.carregarCompartilhamentos();
    }

    //* Carrega os usuarios
    this.carregarUsuarios();
  },

  methods: {
    abrir() {
      this.$emit("dialog-on");
      this.$refs.dialogDiretorioListFiltro.abrir();
    },
    fechar() {
      this.storeArvore.instancias[this.instancia].itensPagina = 1;
      this.storeArvore.atualizar(this.instancia);
      this.$refs.dialogDiretorioListFiltro.fechar();
      this.$emit("dialog-off");
    },

    async carregarUsuarios() {
      const token =
        this.$props.instancia !== "" &&
        this.authStore.token[this.$props.instancia] !== ""
          ? this.authStore.token[this.$props.instancia]
          : localStorage.getItem("ckd");

      //* Carrega os usuarios
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/usuario",
        token
      );
      api.valid(response.data, this.$router);

      //* Define os usuarios
      this.usuarios = [{ id: "", nome: "Todos" }];

      //* Verifica se carregou
      if (response.data.erro == false) {
        //* Percorre os usuarios encontrados
        for (
          let indiceUsuario = 0;
          indiceUsuario < response.data.itens.length;
          indiceUsuario++
        ) {
          //* Insere na lista
          let itemUsuario = response.data.itens[indiceUsuario];
          this.usuarios.push({ id: itemUsuario._id, nome: itemUsuario.nome });
        }
      }
    },
    async carregarCompartilhamentos() {
      this.compartilhamentos = [];

      //* Carrega os compartilhamentos
      const response = await api.get(
        this.authStore.apiNuvem(this.instancia) +
          "/diretorio/list?compartilhamento&somenteDiretorios=true",
        this.authStore.token[this.instancia] !== ""
          ? this.authStore.token[this.instancia]
          : null
      );
      api.valid(response.data, this.$router);

      //* Verifica se carregou
      if (response.data.erro == false) {
        //* Define os compartilhamentos
        this.compartilhamentos = [{ id: "", nome: "Selecione..." }];

        //* Percorre os compartilhamentos encontrados
        for (
          let indiceCompartilhamento = 0;
          indiceCompartilhamento < response.data.itens.length;
          indiceCompartilhamento++
        ) {
          //* Insere na lista
          let itemCompartilhamento =
            response.data.itens[indiceCompartilhamento];
          this.compartilhamentos.push({
            id: itemCompartilhamento.compartilhamento._id,
            nome: itemCompartilhamento.nome
          });
        }
      }
    },
    limpar() {
      this.storeArvore.limparFiltro(this.instancia);
    }
  }
};
</script>

<style></style>
